import APIKit from "../Allapis/Apikit/apikit";

export const createCharging = async (values) => {
  try {
    const url = `/transactions`;
    const res = await APIKit.post(url, values);
    return res.data;
  } catch (e) {
    console.log(e, "Error in creating charging");
    return e.response ? e.response.data : e;
  }
};

